<template>
<div class="css-info">
  <div style="text-align:left;width:100%">
    <p>社員情報
      <!-- <a style="float:right;" href="/edit">edit</a> -->
      <a-button style="float:right;" @click="onEditClicked" size="small">edit</a-button>
    </p>
  </div>
  <div class="css-info-uneditable">
    <a-card :loading="isLoading" hoverable :bodyStyle="{padding:'5px'}">
      <div class="css-info-main">
        <a-row>
          <a-col :span="5">
            <span>社員ID</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col :span="5">
            <span>{{info.eid}}</span>
          </a-col>
          <a-col :span="2">
            <span>名前</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col :span="10">
            <a-button size="small" disabled>{{info.name}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>アカウント</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{info.account}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>メール</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{info.email}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>入社日付</span>
          </a-col>
          <a-col :span="1">
            <span>：</span>
          </a-col>
          <a-col>
            <span>{{info.joined_at}}</span>
          </a-col>
        </a-row>
      </div>
      <a-divider/>
      <div class="css-info-sub">
        <a-row>
          <a-col :span="5">
            <span>性別</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-radio-group :defaultValue="info.sex" :options="sex_options" disabled style="float:left" />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>誕生日</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled icon="calendar">{{info.birthday}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>住所</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>
              〒{{info.postal_code}}
              <br> {{info.address}}
            </a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>携帯</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{info.telphone}}</a-button>
          </a-col>
        </a-row>
      </div>
      <a-card type="inner" style="margin-top:10px">
        <div slot="title" style="padding:0px;margin:0px;text-align:left;">
          <a-tag color="red">緊急連絡先</a-tag>
          <a-tag style="margin-left:10px" color="green" v-if="info.emergency_contact_relation">{{info.emergency_contact_relation}}</a-tag>
        </div>
        <a-row>
          <a-col :span="5">
            <span>名前</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{info.emergency_contact_name}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>携帯</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{info.emergency_contact_telphone}}</a-button>
          </a-col>
        </a-row>
      </a-card>
      <a-card type="inner" 　style="margin-top:10px">
        <div slot="title" style="padding:0px;margin:0px;text-align:left;">
          <a-tag color="red">ビザ情報</a-tag>
        </div>
        <a-row>
          <a-col :span="6">
            <span>在留期限</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled icon="calendar">{{info.residence_card_expired}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="6">
            <span>パスポート</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled icon="calendar">{{info.passport_expired}}</a-button>
          </a-col>
        </a-row>
      </a-card>
    </a-card>
  </div>
</div>
</template>

<script>
const sex_options = [{
    label: "女",
    value: "female"
  },
  {
    label: "男",
    value: "male"
  },
  {
    label: "未設定",
    value: "unknown"
  }
];
export default {
  data() {
    return {
      sex_options,
      loading: false,
      employee: null,
      info: {
        eid: "",
        name: "",
        account: "",
        email: "",
        joined_at: "",
        birthday: "",
        sex: "",
        postal_code: "",
        address: "",
        telphone: "",
        emergency_contact_relation: "",
        emergency_contact_name: "",
        emergency_contact_telphone: "",
        residence_card_expired: "",
        passport_expired: ""
      }
    };
  },
  methods: {
    handleClick() {
      this.loading = !this.loading;
    }
  },
  created() {
    this.isLoading = true;
    let token = this.$store.getters.token;

    this.$api.employee
      .queryOne({
        eid: this.eid,
        token: token
      })
      .then(data => {
        let resp = data.data;
        this.isLoading = false;
        this.$logger.d("Info", "api.employee.queryOne", {
          response: resp
        });
        if (resp.error) {
          // this.$notification.error({
          //   message: "エラー:" + resp.error.code,
          //   description: resp.error.description
          // });
          // this.$router.push({
          //   path: "/"
          // });
          this.$error_handler(this,resp.error)
        } else {
          let employee = resp.result.employee;
          this.employee = employee;
          this.info.eid = employee.eid;
          this.info.name =
            employee.user.userinfo.lastname +
            " " +
            employee.user.userinfo.firstname;
          this.info.account = employee.user.account;
          this.info.email = employee.user.email;
          this.info.joined_at = employee.joined_at;
          this.info.birthday = employee.user.userinfo.birthday;
          this.info.sex = employee.user.userinfo.sex;
          this.info.postal_code = employee.user.userinfo.postal_code;
          this.info.address = employee.user.userinfo.address;
          this.info.telphone = employee.user.userinfo.telphone;
          this.info.emergency_contact_relation =
            employee.employeeinfo.emergency_contact_relation;
          this.info.emergency_contact_name =
            employee.employeeinfo.emergency_contact_name;
          this.info.emergency_contact_telphone =
            employee.employeeinfo.emergency_contact_telphone;
          this.info.residence_card_expired =
            employee.employeeinfo.residence_card_expired;
          this.info.passport_expired = employee.employeeinfo.passport_expired;
        }
      })
      .catch(err => {
        this.$logger.e("Login", "api", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
        this.$router.push({
          path: "/"
        });
      });
  },
  methods: {
    onEditClicked() {
      this.$router.push({
        name: "edit",
        params: {
          info: this.employee,
          canEditName: false
        }
      });
    }
  }
};
</script>
<style scoped>
.css-info {
  padding: 5px 10px 0px 10px;
}

.css-info span {
  float: left;
}

.css-info-uneditable .ant-row {
  margin-top: 10px;
}

.css-info-uneditable button {
  float: left;
  max-width: 100%;
  height: 100%;
  font-size: 12px;
  text-align: left;
}
</style>
